export const generateGroups = (letters, groupCount) => {
  // Function to shuffle an array randomly (Fisher-Yates Shuffle)
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  // Shuffle the letters randomly
  shuffleArray(letters);

  // Create groups of random strings, each of length 5
  let groups = [];
  for (let i = 0; i < groupCount; i++) {
    let group = "";
    for (let j = 0; j < 5; j++) {
      group += letters[Math.floor(Math.random() * letters.length)];
    }
    groups.push(group);
  }

  // Answer Key (Debugger Mode)
  console.log("Generated Groups:", groups.join(" "));

  return groups;
};
